import Header from '../../../Components/Header'
import Pick from './Pick'
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';


const Viewpick = () => {
      const location = useLocation();
  
      const { pick_id } = location.state || {};

  return (
    <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
       <Helmet>
				<title>Picklist - View</title>
			</Helmet>
       <Header />
      <div className="container-fluid maindiv d-flex flex-column " style={{ flexGrow: '1' }}>
        <Pick  pick_id={pick_id} />
       </div>
           </div>

  )
}

export default Viewpick